let inputs

function init(context = document) {
    inputs = context.querySelectorAll('.js-hover-label')
    inputs = Array.prototype.slice.call(inputs)

    setupInitialState()
    addEventListeners()
}

function setupInitialState() {
    inputs.forEach(function(element) {
        if (element.dataset.hoverSetup) {
            return
        }

        if (!element.value) {
            element.classList.remove('has-focus')
        } else if (!element.classList.contains('has-focus')) {
            element.classList.add('has-focus')
        }

        element.dataset.hoverSetup = true
    })
}

function addEventListeners() {
    inputs.forEach(function(element) {
        element.addEventListener('focus', handleFocus)
        element.addEventListener('blur', handleBlur)
    })
}

function handleFocus(evt) {
    if (!evt.target.classList.contains('js-hover-label')) return
    evt.target.classList.add('has-focus')
}

function handleBlur(evt) {
    if (!evt.target.classList.contains('js-hover-label')) return
    if (!evt.target.value) {
        evt.target.classList.remove('has-focus')
    }
}

export default init
